import { render, staticRenderFns } from "./EditarDocumento.vue?vue&type=template&id=976831fa&"
import script from "./EditarDocumento.vue?vue&type=script&lang=js&"
export * from "./EditarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports